import { cva } from 'class-variance-authority';
/** 필드 공통 크롬 — 글래스 위에서도 묻히지 않게 불투명 background. */
const inputBase = 'flex w-full min-w-0 rounded-md border border-input bg-background px-3 text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:bg-input/40 dark:aria-invalid:ring-destructive/40 md:text-sm';
/** 높이는 --control-height-* (rules-tokens). default는 md 별칭. */
const inputSizeMap = {
    default: 'h-[length:var(--control-height)] py-1',
    md: 'h-[length:var(--control-height-md)] py-1',
    sm: 'h-[length:var(--control-height-sm)] py-0.5',
    lg: 'h-[length:var(--control-height-lg)] py-1.5',
};
export const inputCva = {
    variants: {
        size: inputSizeMap,
    },
    defaultVariants: {
        size: 'default',
    },
};
export const inputVariants = cva(inputBase, inputCva);
export const inputSizeKeys = Object.keys(inputCva.variants.size);
/** 레거시 — default size 클래스 문자열. */
export const inputClassName = inputVariants({ size: 'default' });
//# sourceMappingURL=input.cva.js.map